module.exports = __webpack_public_path__ + "img/farewell_6.a0e9c141.jpg";